// extracted by mini-css-extract-plugin
export default {"cls1":"QuestionStyles-cls1___dc9eaa53cd4aae4696b","cls2":"QuestionStyles-cls2__cb4a7324564ce94c2710 QuestionStyles-cls1___dc9eaa53cd4aae4696b"};